// extracted by mini-css-extract-plugin
export var numpadContainer = "_mf-1";
export var phoneButton = "_mf-0";